import { IChecklist } from '../../types';
export enum ActionTypes {
    TOGGLE_CHECK = 'TOGGLE_CHECK',
    INIT_CHECKLIST = 'INIT_CHECKLIST'
}

export type ChecklistState = {
    [key: string]: {
        isChecked: boolean;
    }
}

type ToggleCheck = {
    [key: string]: any,
    type: ActionTypes.TOGGLE_CHECK,
    payload: ChecklistState
}

type InitChecklist = {
    [key: string]: any,
    type: ActionTypes.INIT_CHECKLIST,
    payload: IChecklist
}

export type ChecklistActionTypes = ToggleCheck | InitChecklist;
